export default __webpack_public_path__ + "static/media/wh_ep2_alex.c0efa329.jpg";